import { Col, Row, Select } from 'antd';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

const { Option } = Select;

export const CourierAndOrderFormControls = ({
  destinationCouriers,
  selectedCouriers,
  destinationOrders,
  selectedOrders,
  setCalculatedDestinationOrdersForShowButton,
  value = {},
  onChange,
  index,
}) => {
  const [orders, setOrders] = useState(value.orders || []);
  const { t } = useTranslation();
  const [courier, setCourier] = useState(value.courier || null);
  const [calculatedDestinationCouriers, setCalculatedDestinationCouriers] =
    useState(destinationCouriers);
  const [calculatedDestinationOrders, setCalculatedDestinationOrders] =
    useState(destinationOrders);

  useEffect(() => {
    const data = destinationCouriers.filter((dc) => {
      if (courier === dc.id) {
        return true;
      }
      return !selectedCouriers?.includes(dc.id);
    });

    setCalculatedDestinationCouriers(data);
  }, [courier, destinationCouriers, selectedCouriers, index]);

  useEffect(() => {
    const data = destinationOrders.filter((dc) => {
      if (orders?.includes(dc.orderId)) {
        return true;
      }
      const isSelected = selectedOrders.some((selectedOrder) =>
        selectedOrder?.includes(dc.orderId),
      );

      return !isSelected;
    });

    setCalculatedDestinationOrders(data);
    setCalculatedDestinationOrdersForShowButton(data);
  }, [orders, destinationOrders, selectedOrders]);

  const triggerChange = (changedValues) => {
    onChange?.({
      courier,
      orders,
      ...value,
      ...changedValues,
    });
  };

  const onCourierChange = (value) => {
    setCourier(value);
    triggerChange({ courier: value });
  };

  const onOrdersChange = (selectedOrders) => {
    if (selectedOrders.includes('selectAll')) {
      selectedOrders = calculatedDestinationOrders.map(
        (order) => order?.orderId,
      );
    }
    setOrders(selectedOrders);
    triggerChange({ orders: selectedOrders });
  };

  return (
    <Row>
      <Col span={12}>
        <Select
          value={value.courier || courier}
          style={{ width: '100%' }}
          placeholder={t('routingDetail.selectDestinationCourier')}
          onChange={(v) => onCourierChange(v)}
          showSearch
          filterOption={(input, option) =>
            (option?.children ?? '').toLowerCase().includes(input.toLowerCase())
          }
        >
          {calculatedDestinationCouriers.map((courier) => (
            <Option key={courier.id} value={courier.id}>
              {courier.fullName}
            </Option>
          ))}
        </Select>
      </Col>

      <Col span={11} offset={1}>
        <Select
          value={value.orders || orders}
          onChange={(o) => onOrdersChange(o)}
          mode="multiple"
          placeholder={t('routingDetail.selectOrders')}
          allowClear
          maxTagCount={1}
          optionLabelProp="label"
          showSearch
          filterOption={(input, option) =>
            (option?.children ?? '').toLowerCase().includes(input.toLowerCase())
          }
        >
          <Option key="selectAll" value="selectAll" label={t('selectAll')}>
            {t('selectAll')}
          </Option>
          {calculatedDestinationOrders?.map((order, index) => (
            <Option
              key={order?.orderId}
              value={order?.orderId}
              label={`${order?.customerOrderNumber} / ${order?.customerName}`}
            >
              {`${order?.customerOrderNumber} / ${order?.customerName}`}
            </Option>
          ))}
        </Select>
      </Col>
    </Row>
  );
};

export default CourierAndOrderFormControls;
